import PermintaanProduksiApi from './PermintaanProduksiApi';

export default PermintaanProduksiApi;
